import { render } from "./SearchInput.vue?vue&type=template&id=66bea277&scoped=true"
import script from "./SearchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchInput.vue?vue&type=style&index=0&id=66bea277&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bea277"],['__file',"src/components/UI/SearchInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66bea277"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66bea277', __exports__)) {
    api.reload('66bea277', __exports__)
  }
  
  module.hot.accept("./SearchInput.vue?vue&type=template&id=66bea277&scoped=true", () => {
    api.rerender('66bea277', render)
  })

}


export default __exports__